var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup34(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.923,
    height: 138.261,
    viewBox: "0 0 180.923 138.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(-1135.882 -1571.981)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M2318.8,641.8h-8.815l14.935-27.728v21.608a6.124,6.124,0,0,1-6.12,6.12",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M2359.025,611.487l-39.465,73.3L2294.2,671.115l12.29-22.825H2318.8a12.638,12.638,0,0,0,12.614-12.614V614.02a12.463,12.463,0,0,0-2.451-7.452l4.691-8.718Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M2315.92,691.533l-.018.005-11.92,6.959-11.932,6.981-.74-13.8-.741-13.8,12.673,6.823Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 22.382,
    height: 28.798,
    transform: "matrix(0.474, -0.88, 0.88, 0.474, 1280.838, 1591.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M2274.921,710.246c-7.095,0-10.744-4.3-13.41-7.442-2.385-2.814-3.548-4.057-6.1-4.057s-3.722,1.243-6.113,4.058c-2.666,3.14-6.315,7.441-13.416,7.441s-10.756-4.3-13.426-7.439c-2.39-2.817-3.556-4.06-6.118-4.06s-3.727,1.243-6.118,4.06c-2.669,3.14-6.321,7.439-13.422,7.439a4.792,4.792,0,0,1,0-9.585c2.561,0,3.727-1.243,6.118-4.059,2.669-3.14,6.322-7.44,13.422-7.44s10.753,4.3,13.423,7.438c2.391,2.817,3.559,4.061,6.121,4.061s3.721-1.243,6.112-4.058c2.667-3.14,6.316-7.441,13.417-7.441s10.743,4.3,13.41,7.443c2.385,2.813,3.547,4.056,6.1,4.056a4.792,4.792,0,0,1,0,9.585",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M2318.8,607.9h-1.477c0-.081.015-.146.015-.227V593.856a9.968,9.968,0,0,0-9.966-9.967h-8.247a9.969,9.969,0,0,0-9.968,9.967v13.881c0,.048.016.1.016.162h-1.477a6.125,6.125,0,0,0-6.121,6.12v21.656a6.126,6.126,0,0,0,6.121,6.121h31.1a6.125,6.125,0,0,0,6.12-6.121V614.019a6.124,6.124,0,0,0-6.12-6.12m-23.8,0c0-.065-.017-.114-.017-.162V593.856a4.137,4.137,0,0,1,4.141-4.139h8.247a4.137,4.137,0,0,1,4.139,4.139v13.816c0,.081-.017.146-.017.227Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup34);
export default __webpack_public_path__ + "static/media/Group 34.4e03a04efb6541608bf16dba423f06aa.svg";
export { ForwardRef as ReactComponent };